module.exports = __webpack_public_path__ + "d6566a19e814e3ef3d3661c81ced6cf1.svg";